export default __webpack_public_path__ + "static/media/38.6bc6eac4.jpg";